import TextfieldSimple from "../generalComponents/TextInputField/TextfieldSimple";
import NavBar from "../generalComponents/NavBar";
import NewBlogComponent from "./blogSubComponents/NewBlogComponent";

const CreateNewBlogPage = () => {

    return(
      <div>
          <NavBar></NavBar>
          <NewBlogComponent></NewBlogComponent>
      </div>
    );

}

export default CreateNewBlogPage;
